import { Injectable } from '@angular/core';
import { NbNativeDateService } from '@nebular/theme';
import { DATE_FORMAT } from '../constants/date-format.constant';

// The native date service doesn't allow a `format` on <nb-datepicker>, and without one it falls back
// to DatePipe's 'mediumDate' (e.g. "Oct 8, 2026"). Default to DATE_FORMAT instead. Parsing still uses
// Date.parse, which accepts MM/dd/yyyy.
@Injectable()
export class AppNativeDateService extends NbNativeDateService {
  override format(date: Date, format?: string): string {
    return super.format(date, format || DATE_FORMAT);
  }
}
